import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_landing/Header/_Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_landing/Header/Header.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_landing/Footer/Footer.module.scss");
